// @ts-check
import { getColor } from '@linearb/linui-common';

function getLoggerStyle(color = 'white') {
  return `padding: 0.08rem 1rem;
  border-radius: 2.3rem;
  font-weight: 700;
  text-align: center;
  color: ${getColor(color)};
  border: 1px solid ${getColor(color)};
  background-color: ${getColor(color, 0.2)};
  margin: 2px;`;
}

/**
 *
 * @param {string} message
 * @param {string} color
 * @param {object|string} properties
 */
export function log(message = '', color = 'white', properties = '') {
  // eslint-disable-next-line no-console
  console.log(message, getLoggerStyle(color), properties);
}
